<template>
  <div class="bill-wrap">
    <div class="bill-header">
      <div>
        <div class="flex-wrap">
          <h3>
          </h3>
          <el-radio-group v-model="type" size="mini" @change="typeChange">
            <el-radio label="票据识别" border>票据识别</el-radio>
            <!--<el-radio label="银行卡" border>银行卡</el-radio>-->
            <!--<el-radio label="身份证" border>身份证</el-radio>-->
            <el-radio label="营业执照" border>营业执照</el-radio>
            <el-radio label="小语种" border>小语种</el-radio>
            <!-- <el-radio label="护照" border>护照</el-radio> -->
            <el-radio label="印章" border>印章</el-radio>
            <el-radio label="海关税单" border>海关税单</el-radio>
            <el-radio label="报关单识别" border>报关单识别</el-radio>
            <el-radio label="手写体识别" border>手写体识别</el-radio>
          </el-radio-group>
        </div>
        <div style="font-size: 15px;">
          <div style="display: flex;align-items: center;">
            <div v-show="fileName">文件名： <span style="font-weight: 600;margin-right: 20px;">{{fileName}}</span></div>
            <el-upload v-if="uploadURL" v-show="fileName" class="upload-demo" accept=".jpeg,.jpg,.png"
              :auto-upload="true" :action="uploadURL" :on-success="uploadSuccess" :headers="uploadHeaders"
              :before-upload="beforeUpload" :on-change="uploadChange" :on-error="uploadError">
              <el-button size="small" type="primary">重新上传</el-button>
            </el-upload>
          </div>
        </div>
      </div>
    </div>
    <div style="padding: 10px 15px;" v-if="type === '小语种'">
      <el-radio-group v-model="selectedLang" size="mini" @change="selectedLangChange">
        <el-radio-button v-for="(item,index) in langArr" :label="item.value">{{item.name}}</el-radio-button>
      </el-radio-group>
    </div>
    <div class="content"
      :style="{'margin-top': type === '小语种' ? 0 : '20px', 'height': type === '小语种' ? 'calc(100% - 170px)' : 'calc(100% - 130px)'}">
      <template v-if="type === '票据识别'">
        <iframe width="100%" height="100%" src="https://ai.xiantaiai.com/ocr"></iframe>
      </template>
      <template v-else-if="type === '海关税单'">
        <iframe width="100%" height="100%" src="https://ocr.you.xin:446"></iframe>
      </template>
      <template v-else-if="type === '报关单识别'">
        <iframe width="100%" height="100%" src="https://decl-ocr.you.xin"></iframe>
      </template>
      <template v-else-if="type === '手写体识别'">
        <iframe width="100%" height="100%" src="https://ocr_hand.you.xin"></iframe>
      </template>
      <template v-else>
        <div class="left" v-loading="loading">
          <el-image class="img-sty" v-if="imgUrl" :src="imgUrl" :preview-src-list="[imgUrl]">
          </el-image>
          <iframe width="100%" v-else-if="pdfBase64" height="100%" frameborder="0" scrolling="auto"
            :src="pdfBase64"></iframe>
          <el-upload v-else accept=".jpeg,.jpg,.png" class="upload-demo" drag :auto-upload="true" :action="uploadURL"
            :on-success="uploadSuccess" :before-upload="beforeUpload" :headers="uploadHeaders" :on-change="uploadChange"
            :on-error="uploadError">
            <div class="text">
              <i class="el-icon-upload"></i>
            </div>
            <!-- <div class="el-upload__text">将图片拖到此处，或<em> 点击上传</em></div> -->
            <div class="el-upload__tip" slot="tip">只能上传jpg/png文件（支持拖拽上传），且不超过2mb</div>
          </el-upload>
        </div>
        <div class="right">
          <el-tabs v-model="activeName" class="yc-tabs" ref="tabs" type="card" style="margin: 20px;">
            <el-tab-pane label="OCR识别结果" name="ocr" key="ocr">
              <div :style="{'height': height,'overflow-y': 'scroll'}">
                <template v-if="invoicesData.length > 0">
                  <div class="ocr-sty" v-for="item in invoicesData">
                    <el-form style="padding: 20px;" label-position="left" label-width="200px">
                      <template v-for="fieldName in Object.keys(invoicesData[0])">
                        <el-form-item :label="fieldName+'：'">
                          <template v-if="fieldName === '原始票据类型'">
                            {{item[fieldName] | originType}}
                          </template>
                          <template v-else>
                            {{item[fieldName]}}
                          </template>
                        </el-form-item>
                      </template>
                    </el-form>
                  </div>
                </template>
                <template v-if="taxiTickets.length > 0">
                  <div class="ocr-sty" v-for="item in taxiTickets">
                    <el-form style="padding: 20px;" label-position="left" label-width="200px">
                      <template v-for="fieldName in Object.keys(taxiTickets[0])">
                        <el-form-item :label="fieldName+'：'">
                          <template v-if="fieldName === '原始票据类型'">
                            {{item[fieldName] | originType}}
                          </template>
                          <template v-else>
                            {{item[fieldName]}}
                          </template>
                        </el-form-item>
                      </template>
                    </el-form>
                  </div>
                </template>
                <template v-if="trainTickets.length > 0">
                  <div class="ocr-sty" v-for="item in trainTickets">
                    <el-form style="padding: 20px;" label-position="left" label-width="200px">
                      <template v-for="fieldName in Object.keys(trainTickets[0])">
                        <el-form-item :label="fieldName+'：'">
                          <template v-if="fieldName === '原始票据类型'">
                            {{item[fieldName] | originType}}
                          </template>
                          <template v-else>
                            {{item[fieldName]}}
                          </template>
                        </el-form-item>
                      </template>
                    </el-form>
                  </div>
                </template>
                <template v-if="volumeTickets.length > 0">
                  <div class="ocr-sty" v-for="item in volumeTickets">
                    <el-form style="padding: 20px;" label-position="left" label-width="200px">
                      <template v-for="fieldName in Object.keys(volumeTickets[0])">
                        <el-form-item :label="fieldName+'：'">
                          <template v-if="fieldName === '原始票据类型'">
                            {{item[fieldName] | originType}}
                          </template>
                          <template v-else>
                            {{item[fieldName]}}
                          </template>
                        </el-form-item>
                      </template>
                    </el-form>
                  </div>
                </template>
                <template v-if="electricTickets.length > 0">
                  <div class="ocr-sty" v-for="item in electricTickets">
                    <el-form style="padding: 20px;" label-position="left" label-width="200px">
                      <template v-for="fieldName in Object.keys(electricTickets[0])">
                        <el-form-item :label="fieldName+'：'">
                          <template v-if="fieldName === '原始票据类型'">
                            {{item[fieldName] | originType}}
                          </template>
                          <template v-else>
                            {{item[fieldName]}}
                          </template>
                        </el-form-item>
                      </template>
                    </el-form>
                  </div>
                </template>
                <template v-if="machineTickets.length > 0">
                  <div class="ocr-sty" v-for="item in machineTickets">
                    <el-form style="padding: 20px;" label-position="left" label-width="200px">
                      <template v-for="fieldName in Object.keys(machineTickets[0])">
                        <el-form-item :label="fieldName+'：'">
                          <template v-if="fieldName === '原始票据类型'">
                            {{item[fieldName] | originType}}
                          </template>
                          <template v-else>
                            {{item[fieldName]}}
                          </template>
                        </el-form-item>
                      </template>
                    </el-form>
                  </div>
                </template>
                <template v-if="quotaInvoice.length > 0">
                  <div class="ocr-sty" v-for="item in quotaInvoice">
                    <el-form style="padding: 20px;" label-position="left" label-width="200px">
                      <template v-for="fieldName in Object.keys(quotaInvoice[0])">
                        <el-form-item :label="fieldName+'：'">
                          <template v-if="fieldName === '原始票据类型'">
                            {{item[fieldName] | originType}}
                          </template>
                          <template v-else>
                            {{item[fieldName]}}
                          </template>
                        </el-form-item>
                      </template>
                    </el-form>
                  </div>
                </template>
                <template v-if="airTickets.length > 0">
                  <div class="ocr-sty" v-for="item in airTickets">
                    <el-form style="padding: 20px;" label-position="left" label-width="200px">
                      <template v-for="fieldName in Object.keys(airTickets[0])">
                        <el-form-item :label="fieldName+'：'">
                          <template v-if="fieldName === '原始票据类型'">
                            {{item[fieldName] | originType}}
                          </template>
                          <template v-else>
                            {{item[fieldName]}}
                          </template>
                        </el-form-item>
                      </template>
                    </el-form>
                  </div>
                </template>
                <template v-if="busShipTickets.length > 0">
                  <div class="ocr-sty" v-for="item in busShipTickets">
                    <el-form style="padding: 20px;" label-position="left" label-width="200px">
                      <template v-for="fieldName in Object.keys(busShipTickets[0])">
                        <el-form-item :label="fieldName+'：'">
                          <template v-if="fieldName === '原始票据类型'">
                            {{item[fieldName] | originType}}
                          </template>
                          <template v-else>
                            {{item[fieldName]}}
                          </template>
                        </el-form-item>
                      </template>
                    </el-form>
                  </div>
                </template>
                <template v-if="tollTickets.length > 0">
                  <div class="ocr-sty" v-for="item in tollTickets">
                    <el-form style="padding: 20px;" label-position="left" label-width="200px">
                      <template v-for="fieldName in Object.keys(tollTickets[0])">
                        <el-form-item :label="fieldName+'：'">
                          <template v-if="fieldName === '原始票据类型'">
                            {{item[fieldName] | originType}}
                          </template>
                          <template v-else>
                            {{item[fieldName]}}
                          </template>
                        </el-form-item>
                      </template>
                    </el-form>
                  </div>
                </template>
                <template v-if="taxiOnlineTicket.length > 0">
                  <div class="ocr-sty" v-for="item in taxiOnlineTicket">
                    <el-form style="padding: 20px;" label-position="left" label-width="200px">
                      <template v-for="fieldName in Object.keys(taxiOnlineTicket[0])">
                        <el-form-item :label="fieldName+'：'">
                          <template v-if="fieldName === '原始票据类型'">
                            {{item[fieldName] | originType}}
                          </template>
                          <template v-else>
                            {{item[fieldName]}}
                          </template>
                        </el-form-item>
                      </template>
                    </el-form>
                  </div>
                </template>
                <template v-if="bankCard.length > 0">
                  <div class="ocr-sty" v-for="item in bankCard">
                    <el-form style="padding: 20px;" label-position="left" label-width="200px">
                      <template v-for="fieldName in Object.keys(bankCard[0])">
                        <el-form-item :label="fieldName+'：'">
                          <template>
                            {{item[fieldName]}}
                          </template>
                        </el-form-item>
                      </template>
                    </el-form>
                  </div>
                </template>
                <template v-if="type === '小语种'">
                  <div class="ocr-result-wrap">
                    <template v-if="jsonData.length === 0 ">
                      <div class="noMsg"></div>
                    </template>
                    <template v-else>
                      <div class="search">
                        <!-- <el-input placeholder="请输入内容搜索" prefix-icon="el-icon-search" v-model="inputOcr" @change="searchChange"></el-input> -->
                      </div>
                      <div>
                        <div class="row" style="margin-bottom: 10px;" v-for="(item,index) in jsonData[0]" ref="row"
                          :key="index">
                          <div style="display: inline-block; width:3%;color: #484949;font-size: 14px;">
                            <p>{{index+1}}</p>
                          </div>
                          <div style="display: inline-block;width:90%">
                            <span class="filed" v-for="(x,i) in item" :key="i" ref="word" v-html="x.words"></span>
                          </div>
                        </div>
                      </div>
                      <div class="buttonshib">
                        <!-- <el-button size="small" type="test" class="jiucbun" @click="errorjiuzhneg()" style="text-align: center;padding: inherit;float: right;margin-right: 30px;width: 124px;height: 32px;">识别结果纠错</el-button> -->
                      </div>
                    </template>
                  </div>
                </template>
              </div>
            </el-tab-pane>
            <el-tab-pane label="JSON结果" name="json" key="json">
              <template v-if="jsonData.length > 0">
                <div :style="{'height': height,'overflow-y': 'scroll'}">
                  <json-viewer :show-double-quotes="true" :expanded="expanded" show-array-index :expand-depth="5"
                    copyable boxed :value="jsonData"></json-viewer>
                </div>
              </template>
            </el-tab-pane>
          </el-tabs>
          <i v-if="jsonData.length === 0 " class="el-icon-document"></i>
        </div>
      </template>
    </div>
  </div>
</template>
<script>
  import JsonViewer from 'vue-json-viewer/ssr'
  import 'vue-json-viewer/style.css'

  export default {
    props: {},
    data() {
      return {
        fileName: '请上传识别文件',
        url: 'https://fuss10.elemecdn.com/e/5d/4a731a90594a4af544c0c25941171jpeg.jpeg',
        srcList: [
          'https://fuss10.elemecdn.com/8/27/f01c15bb73e1ef3793e64e6b7bbccjpeg.jpeg',
          'https://fuss10.elemecdn.com/1/8e/aeffeb4de74e2fde4bd74fc7b4486jpeg.jpeg'
        ],
        activeName: 'ocr',
        uploadURL: this.$invoiceRecognitionUpload.url,
        uploadHeaders: null,
        jsonData: [],
        expanded: true,
        height: document.documentElement.clientHeight - 250 + 'px',
        fileList: [],
        invoicesData: [],
        taxiTickets: [],
        trainTickets: [],
        volumeTickets: [],
        electricTickets: [],
        machineTickets: [],
        quotaInvoice: [],
        // 机票
        airTickets: [],
        busShipTickets: [],
        tollTickets: [],
        taxiOnlineTicket: [],
        fileName: '',
        imgUrl: '',
        pdfBase64: '',
        loading: false,
        type: '票据识别',
        bankCard: [],
        langArr: [
          { name: '德语', value: 'EURO_ALL_ATT_GER' }, { name: '日语', value: 'JAP' }, { name: '韩语', value: 'KOR' }, { name: '法语', value: 'FRE' }, { name: '西班牙语', value: 'SPA' }, { name: '葡萄牙语', value: 'POR' }, { name: '意大利语', value: 'ITA' }, { name: '俄语', value: 'RUS' }, { name: '丹麦语', value: 'DAN' }, { name: '荷兰语', value: 'DUT' }, { name: '马来语', value: 'MAL' }, { name: '瑞典语', value: 'SWE' }, { name: '印尼语', value: 'IND' }, { name: '波兰语', value: 'POL' }, { name: '罗马尼亚语', value: 'ROM' }, { name: '土耳其语', value: 'TUR' }, { name: '希腊语', value: 'GRE' }, { name: '匈牙利语', value: 'HUN' }, { name: '泰语', value: 'THA' }, { name: '越南语', value: 'VIE' }, { name: '阿拉伯语', value: 'ARA' }, { name: '印地语', value: 'HIN' }
        ],
        selectedLang: 'EURO_ALL_ATT_GER',
        sessionId: ''
      }
    },
    computed: {
    },
    components: {
      JsonViewer
    },
    watch: {
    },
    created() { },
    mounted() {
      // 依赖DashIndex.vue 中设置sessionStorage'BAILIAN-SHIBIE-OFFICEWEBSITE-TOKEN'
      setTimeout(() => {
        // 先获取官网token，在赋值
        this.uploadHeaders = this.$header()
      }, 500)
    },
    methods: {
      beforeUpload(file) {
        this.loading = true
        //单个文件小于10M
        let size = file.size / 1024 / 1024
        const isLt2M = size < 2 && size !== 0

        if (size === 0) {
          this.$message.error('不支持空文件上传')
          return false
        }
        if (!isLt2M) {
          this.$message.error('上传失败，' + file.name + ' 大小超出10M')
          return false
        }
        return isLt2M
      },
      async uploadSuccess(response, file, fileList) {
        this.bankCard = []
        this.jsonData = []
        if (response) {
          this.loading = false
          this.fileName = file.name
          this.$message.success('识别成功');

          let _that = this;
          if (file.name.toUpperCase().includes('.PDF')) {
            _that.imgUrl = ''
            // 创建一个新的 FileReader 对象
            var reader = new FileReader();
            // 定义读取完成时的回调函数
            reader.onload = function (event) {
              // 将文件内容转换为 Base64 编码
              var base64Content = event.target.result.split(',')[1]; // 获取 Base64 部分
              _that.pdfBase64 = 'data:application/pdf;base64,' + base64Content + '#view=FitH,top';
              // 在这里你可以对 base64Content 进行进一步处理，比如放入 iframe 中或上传至服务器等操作
            };
            // 读取文件内容，并以 Data URL 的形式返回
            reader.readAsDataURL(file.raw);
          } else {
            this.imgUrl = this.getImg(file.raw); //图片地址
            this.pdfBase64 = ''
          }

          if (response.status === 200) {
            let data = (response.code && response.code === 1) ? response.data : JSON.parse(response.data)
            this.jsonData = []

            for (let key in data) {
              if (Array.isArray(data[key]) && data[key].length === 0) {
                delete data[key];
              }
            }

            this.jsonData = [data]
            if (data) {
              // 增值税专用发票
              if (data.invoices && data.invoices.length > 0) {
                this.invoicesData = data.invoices.map(item => {
                  let newObj = {
                    '原始票据类型': item.originType,
                    "票据类型编码": item.billTypeInvoice,
                    "发票号码": item.billingCode,
                    '发票代码': item.billingNo,
                    '开票日期': item.billingTime,
                    '是否代开': item.agentMark,
                    '区块链标志': item.blockChain,
                    '购方名称': item.buyerName,
                    '购方地址电话': item.buyerAddressAndPhone,
                    '购方开户行及账号': item.buyerBankAccount,
                    '购方识别号': item.buyerNumber,
                    '校验码': item.checkCode,
                    '密码区': item.ciphertext,
                    '省': item.province,
                    '市': item.city,
                    '机打代码': item.machineCode,
                    "机打号码": item.machineNumber,
                    '是否有公司印章': item.companySeal,
                    '是否有销售方（章）标记': item.companySealMark,
                    '电子标志': item.electronicMark,
                    '发票联次': item.formName,
                    '发票是第几联': item.formType,
                    '开票人': item.maker,
                    '品名': item.itemNames,
                    '通行日期起-明细列表': '',
                    '通行日期止-明细列表': '',
                    '通行费车牌号-明细列表': '',
                    '项目名称-明细列表': '',
                    '单价-明细列表': '',
                    '项目数量-明细列表': '',
                    '规格型号-明细列表': '',
                    '税额-明细列表': '',
                    '税率-明细列表': '',
                    '金额-明细列表': '',
                    '项目单位-明细列表': '',
                    '收款人': item.receiptor,
                    '备注': item.remarks,
                    '复核人': item.reviewer,
                    '销方名称': item.sellerName,
                    '销方地址电话': item.sellerAddressAndPhone,
                    '销方开户行及账号': item.sellerBankAccount,
                    '销方识别号': item.sellerNumber,
                    '服务类型': item.serviceName,
                    '发票章内容': item.stampInfo,
                    '税额': item.tax,
                    '标题': item.title,
                    '合计金额': item.fee,
                    '税前金额': item.feeWithoutTax,
                    '合计金额(大写)': item.totalCn,
                    '通行费标志': item.transitMark,
                    '机动车标志': item.vehicleMark,
                    // 其他信息: item.extra
                    '其他信息-校验码备选': item.extra.checkCodeCandidates,
                    '其他信息-校验码后六位备选': item.extra.checkCodeLastSix,
                    '其他信息-发票号码备选': item.extra.numberOrderError,
                    '其他信息-二维码': item.extra.qrcode,
                    '图片尺寸': item.imageSize,
                    '发票顺时针旋转角度': item.orientation
                  }
                  if (item.items.length > 0) {
                    item.items.forEach((innerObj, index, array) => {
                      newObj['通行日期起-明细列表'] += `${innerObj.startDate}` ? `${innerObj.startDate}${index === array.length - 1 ? '' : ' ，'}` : '';
                      newObj['通行日期止-明细列表'] += `${innerObj.endDate}` ? `${innerObj.endDate}${index === array.length - 1 ? '' : ' ，'}` : '';
                      newObj['通行费车牌号-明细列表'] += `${innerObj.licensePlate}` ? `${innerObj.licensePlate}${index === array.length - 1 ? '' : ' ，'}` : '';
                      newObj['项目名称-明细列表'] += `${innerObj.name}` ? `${innerObj.name}${index === array.length - 1 ? '' : ' ，'}` : '';
                      newObj['单价-明细列表'] += `${innerObj.price}` ? `${innerObj.price}${index === array.length - 1 ? '' : ' ，'}` : '';
                      newObj['项目数量-明细列表'] += `${innerObj.quantity}` ? `${innerObj.quantity}${index === array.length - 1 ? '' : ' ，'}` : '';
                      newObj['规格型号-明细列表'] += `${innerObj.specification}` ? `${innerObj.specification}${index === array.length - 1 ? '' : ' ，'}` : '';
                      newObj['税额-明细列表'] += `${innerObj.tax}` ? `${innerObj.tax}${index === array.length - 1 ? '' : ' ，'}` : '';
                      newObj['税率-明细列表'] += `${innerObj.taxRate}` ? `${innerObj.taxRate}${index === array.length - 1 ? '' : ' ，'}` : '';
                      newObj['金额-明细列表'] += `${innerObj.total}` ? `${innerObj.total}${index === array.length - 1 ? '' : ' ，'}` : '';
                      newObj['项目单位-明细列表'] += `${innerObj.unit}` ? `${innerObj.unit}${index === array.length - 1 ? '' : ' ，'}` : '';
                    });

                  }
                  return newObj
                })
              } else {
                this.invoicesData = []
              }

              // 出租车票
              if (data.taxiTickets && data.taxiTickets.length > 0) {
                this.taxiTickets = data.taxiTickets.map(item => {
                  let newObj = {
                    "原始票据类型": item.originType,
                    "票据类型编码": item.billTypeInvoice,
                    "发票号码": item.billingCode,
                    "发票代码": item.billingNo,
                    "乘车日期": item.billingTime,
                    "省": item.province,
                    "市": item.city,
                    // "其他信息": item.extra,
                    "票价": item.fare,
                    "合计金额": item.fee,
                    "图片尺寸": item.imageSize,
                    "消费类型": item.kind,
                    "车照牌号": item.licensePlate,
                    "里程": item.mileage,
                    "发票顺时针旋转角度": item.orientation,
                    "页码": item.page,
                    "发票所在地": item.place,
                    "坐标": item.region,
                    "下车时间": item.timeGetoff,
                    "上车时间": item.timeGeton,
                  }
                  return newObj
                })
              } else {
                this.taxiTickets = []
              }

              // 火车票
              if (data.trainTickets && data.trainTickets.length > 0) {
                this.trainTickets = data.trainTickets.map(item => {
                  let newObj = {
                    "原始票据类型": item.originType,
                    "票据类型编码": item.billTypeInvoice,
                    "票号": item.billingCode,
                    "乘车日期": item.billingTime,
                    // "其他信息": item.extra,
                    "合计金额": item.fee,
                    "车次": item.flightNumber,
                    "检票口": item.gateNumber,
                    "身份证号": item.identityNumber,
                    "图片尺寸": item.imageSize,
                    "消费类型": item.kind,
                    "发票顺时针旋转角度": item.orientation,
                    "页码": item.page,
                    "乘客姓名": item.passengerName,
                    "取票地址": item.pickUpAddress,
                    "坐标": item.region,
                    "车厢座位号": item.seatNumber,
                    "序列号": item.serialNumber,
                    "下车车站": item.stationGetoff,
                    "上车车站": item.stationGeton,
                    "乘车时间": item.time,
                    "座位等级": item.trainSeatLevel,
                  }
                  return newObj
                })
              } else {
                this.trainTickets = []
              }

              // 卷票
              if (data.volumeTickets && data.volumeTickets.length > 0) {
                this.volumeTickets = data.volumeTickets.map(item => {
                  let newObj = {
                    "原始票据类型": item.originType,
                    "票据类型": item.billTypeInvoice,
                    "发票号码": item.billingCode,
                    "发票代码": item.billingNo,
                    "开票日期": item.billingTime,
                    "购方名称": item.buyerName,
                    "购方识别号": item.buyerNumber,
                    "校验码": item.checkCode,
                    "省": item.province,
                    "市": item.city,
                    "是否有公司印章": item.companySeal,
                    // "其他信息": item.extra,
                    "合计金额": item.fee,
                    "图片尺寸": item.imageSize,
                    "品名": item.itemNames,
                    '项目名称-明细列表': '',
                    '单价-明细列表': '',
                    '项目数量-明细列表': '',
                    '金额-明细列表': '',
                    "消费类型": item.kind,
                    "机打代码": item.machineCode,
                    "机打号码": item.machineNumber,
                    "发票顺时针旋转角度": item.orientation,
                    "页码": item.page,
                    "坐标": item.region,
                    "销方名称": item.sellerName,
                    "销方识别号": item.sellerNumber,
                    "服务类型": item.serviceName,
                    "标题": item.title,
                    "合计金额(大写)": item.totalCn,
                  }
                  if (item.items.length > 0) {
                    item.items.forEach((innerObj, index, array) => {
                      newObj['项目名称-明细列表'] += `${innerObj.name}` ? `${innerObj.name}${index === array.length - 1 ? '' : ' ，'}` : '';
                      newObj['单价-明细列表'] += `${innerObj.price}` ? `${innerObj.price}${index === array.length - 1 ? '' : ' ，'}` : '';
                      newObj['项目数量-明细列表'] += `${innerObj.quantity}` ? `${innerObj.quantity}${index === array.length - 1 ? '' : ' ，'}` : '';
                      newObj['金额-明细列表'] += `${innerObj.total}` ? `${innerObj.total}${index === array.length - 1 ? '' : ' ，'}` : '';
                    });

                  }
                  return newObj
                })
              } else {
                this.volumeTickets = []
              }

              // 电子发票
              if (data.electricTickets && data.electricTickets.length > 0) {
                this.electricTickets = data.electricTickets.map(item => {
                  let newObj = {
                    '原始票据类型': item.originType,
                    "票据类型编码": item.billTypeInvoice,
                    '购方名称': item.buyerName,
                    '购方识别号': item.buyerNumber,
                    '校验码': item.checkCode,
                    '省': item.province,
                    '市': item.city,
                    "发票号码": item.billingCode,
                    '发票代码': item.billingNo,
                    '机打代码': item.machineCode,
                    '是否有公司印章': item.companySeal,
                    '是否有销售方（章）标记': item.companySealMark,
                    '开票日期': item.billingTime,
                    '电子标志': item.electronicMark,
                    '发票是第几联': item.formType,
                    '开票人': item.maker,
                    '品名': item.itemNames,
                    '项目名称-明细列表': '',
                    '单价-明细列表': '',
                    '项目数量-明细列表': '',
                    '规格型号-明细列表': '',
                    '税额-明细列表': '',
                    '税率-明细列表': '',
                    '金额-明细列表': '',
                    '项目单位-明细列表': '',
                    '收款人': item.receiptor,
                    '备注': item.remarks,
                    '复核人': item.reviewer,
                    '销方名称': item.sellerName,
                    '销方识别号': item.sellerNumber,
                    '服务类型': item.serviceName,
                    '税额': item.tax,
                    '标题': item.title,
                    '合计金额': item.fee,
                    '税前金额': item.feeWithoutTax,
                    '合计金额(大写)': item.totalCn,
                    '机动车标志': item.vehicleMark,
                    // 其他信息: item.extra
                    '其他信息-校验码备选': item.extra.checkCodeCandidates,
                    '其他信息-校验码后六位备选': item.extra.checkCodeLastSix,
                    '其他信息-发票号码备选': item.extra.numberOrderError,
                    '其他信息-二维码': item.extra.qrcode,
                    '图片尺寸': item.imageSize,
                    '发票顺时针旋转角度': item.orientation,
                  }
                  if (item.items.length > 0) {
                    item.items.forEach((innerObj, index, array) => {
                      newObj['项目名称-明细列表'] += `${innerObj.name}` ? `${innerObj.name}${index === array.length - 1 ? '' : ' ，'}` : '';
                      newObj['单价-明细列表'] += `${innerObj.price}` ? `${innerObj.price}${index === array.length - 1 ? '' : ' ，'}` : '';
                      newObj['项目数量-明细列表'] += `${innerObj.quantity}` ? `${innerObj.quantity}${index === array.length - 1 ? '' : ' ，'}` : '';
                      newObj['规格型号-明细列表'] += `${innerObj.specification}` ? `${innerObj.specification}${index === array.length - 1 ? '' : ' ，'}` : '';
                      newObj['税额-明细列表'] += `${innerObj.tax}` ? `${innerObj.tax}${index === array.length - 1 ? '' : ' ，'}` : '';
                      newObj['税率-明细列表'] += `${innerObj.taxRate}` ? `${innerObj.taxRate}${index === array.length - 1 ? '' : ' ，'}` : '';
                      newObj['金额-明细列表'] += `${innerObj.total}` ? `${innerObj.total}${index === array.length - 1 ? '' : ' ，'}` : '';
                      newObj['项目单位-明细列表'] += `${innerObj.unit}` ? `${innerObj.unit}${index === array.length - 1 ? '' : ' ，'}` : '';
                    });
                  }
                  return newObj
                })
              } else {
                this.electricTickets = []
              }

              // 机打发票
              if (data.machineTickets && data.machineTickets.length > 0) {
                this.machineTickets = data.machineTickets.map(item => {
                  let newObj = {
                    '原始票据类型': item.originType,
                    "票据类型编码": item.billTypeInvoice,
                    '购方名称': item.buyerName,
                    '购方识别号': item.buyerNumber,
                    '校验码': item.checkCode,
                    '省': item.province,
                    '市': item.city,
                    "发票号码": item.billingCode,
                    '发票代码': item.billingNo,
                    '是否有公司印章': item.companySeal,
                    '开票日期': item.billingTime,
                    '电子标志': item.electronicMark,
                    '项目名称-明细列表': '',
                    '单价-明细列表': '',
                    '项目数量-明细列表': '',
                    '金额-明细列表': '',
                    '项目单位-明细列表': '',
                    '销方名称': item.sellerName,
                    '销方识别号': item.sellerNumber,
                    '标题': item.title,
                    '合计金额': item.fee,
                    '合计金额(大写)': item.totalCn,
                    // 其他信息: item.extra
                    '其他信息-校验码备选': item.extra.checkCodeCandidates,
                    '其他信息-校验码后六位备选': item.extra.checkCodeLastSix,
                    '其他信息-发票号码备选': item.extra.numberOrderError,
                    '图片尺寸': item.imageSize,
                    '发票顺时针旋转角度': item.orientation,
                  }
                  if (item.items.length > 0) {
                    item.items.forEach((innerObj, index, array) => {
                      newObj['项目名称-明细列表'] += `${innerObj.name}` ? ` ${innerObj.name}${index === array.length - 1 ? '' : ' ，'}` : '';
                      newObj['单价-明细列表'] += `${innerObj.price}` ? ` ${innerObj.price}${index === array.length - 1 ? '' : ' ，'}` : '';
                      newObj['项目数量-明细列表'] += `${innerObj.quantity}` ? ` ${innerObj.quantity}${index === array.length - 1 ? '' : ' ，'}` : '';
                      newObj['金额-明细列表'] += `${innerObj.total}` ? ` ${innerObj.total}${index === array.length - 1 ? '' : ' ，'}` : '';
                      newObj['项目单位-明细列表'] += `${innerObj.unit}` ? ` ${innerObj.unit}${index === array.length - 1 ? '' : ' ，'}` : '';
                    });

                  }
                  return newObj
                })
              } else {
                this.machineTickets = []
              }

              // 额定发票
              if (data.quotaInvoice && data.quotaInvoice.length > 0) {
                this.quotaInvoice = data.quotaInvoice.map(item => {
                  let newObj = {
                    '原始票据类型': item.originType,
                    "票据类型编码": item.billTypeInvoice,
                    '省': item.province,
                    '市': item.city,
                    '发票代码': item.billingNo,
                    "发票号码": item.billingCode,
                    "开票日期": item.billingTime,
                    "服务类型": item.serviceName,
                    "合计金额": item.fee,
                    '合计金额(大写)': item.totalCn,
                    "其他信息": item.extra,
                    "图片尺寸": item.imageSize,
                    "发票顺时针旋转角度": item.orientation,
                  }
                  return newObj
                })
              } else {
                this.quotaInvoice = []
              }

              // 航空运输电子客票行程单
              if (data.airTickets && data.airTickets.length > 0) {
                this.airTickets = data.airTickets.map(item => {
                  let newObj = {
                    '原始票据类型': item.originType,
                    '票据类型编码': item.billTypeInvoice,
                    '销售单位代号': item.agentcode,
                    '民航发展基金': item.caacDevelopmentFund,
                    '校验码': item.checkCode,
                    '开票日期': item.billingTime,
                    '签注': item.endorsement,
                    '票价': item.fare,
                    '燃油附加费': item.fuelSurcharge,
                    '保险费': item.insurance,
                    '国内国际标签': item.internationalFlag,
                    '填开单位': item.issueBy,
                    '消费类型': item.kind,
                    '发票号码': item.billingCode,
                    '印刷序号': item.printNumber,
                    '税额': item.tax,
                    '标题': item.title,
                    '合计金额': item.fee,
                    '身份证号': item.identityNumber,
                    '乘机人姓名': item.passengerName,
                    // '其他信息': item.extra,
                    '免费行李重量-明细列表': '',
                    '承运人-明细列表': '',
                    '座位等级-明细列表': '',
                    '乘机日期-明细列表': '',
                    '客票级别-明细列表': '',
                    '航班号-明细列表': '',
                    '出发地-明细列表': '',
                    '座位等级-明细列表': '',
                    '座位等级-明细列表': '',
                    '到达地-明细列表': '',
                    '校验码备选': item.extra.checkCodeCandidates,
                    '图片尺寸': item.imageSize,
                    '发票顺时针旋转角度': item.orientation,
                  }
                  if (item.details.length > 0) {
                    item.details.forEach((innerObj, index, array) => {
                      newObj['免费行李重量-明细列表'] += `${innerObj.allow}` ? `${innerObj.allow}${index === array.length - 1 ? '' : ' ，'}` : '';
                      newObj['承运人-明细列表'] += `${innerObj.carrier}` ? `${innerObj.carrier}${index === array.length - 1 ? '' : ' ，'}` : '';
                      newObj['座位等级-明细列表'] += `${innerObj.className}` ? `${innerObj.className}${index === array.length - 1 ? '' : ' ，'}` : '';
                      newObj['乘机日期-明细列表'] += `${innerObj.date}` ? `${innerObj.date}${index === array.length - 1 ? '' : ' ，'}` : '';
                      newObj['客票级别-明细列表'] += `${innerObj.fareBasis}` ? `${innerObj.fareBasis}${index === array.length - 1 ? '' : ' ，'}` : '';
                      newObj['航班号-明细列表'] += `${innerObj.flightNumber}` ? `${innerObj.flightNumber}${index === array.length - 1 ? '' : ' ，'}` : '';
                      newObj['出发地-明细列表'] += `${innerObj.origin}` ? `${innerObj.origin}${index === array.length - 1 ? '' : ' ，'}` : '';
                      newObj['座位等级-明细列表'] += `${innerObj.seat}` ? `${innerObj.seat}${index === array.length - 1 ? '' : ' ，'}` : '';
                      newObj['座位等级-明细列表'] += `${innerObj.time}` ? `${innerObj.time}${index === array.length - 1 ? '' : ' ，'}` : '';
                      newObj['到达地-明细列表'] += `${innerObj.destination}` ? `${innerObj.destination}${index === array.length - 1 ? '' : ' ，'}` : '';
                    });

                  }
                  return newObj
                })
              } else {
                this.airTickets = []
              }

              // 汽车票
              // 火车票
              if (data.busShipTickets && data.busShipTickets.length > 0) {
                this.busShipTickets = data.busShipTickets.map(item => {
                  let newObj = {
                    "原始票据类型": item.originType,
                    "票据类型编码": item.billTypeInvoice,
                    "票号": item.billingCode,
                    "乘车日期": item.billingTime,
                    // "其他信息": item.extra,
                    "合计金额": item.fee,
                    "车次": item.flightNumber,
                    "检票口": item.gateNumber,
                    "身份证号": item.identityNumber,
                    "图片尺寸": item.imageSize,
                    "消费类型": item.kind,
                    "发票顺时针旋转角度": item.orientation,
                    "页码": item.page,
                    "乘客姓名": item.passengerName,
                    "取票地址": item.pickUpAddress,
                    "坐标": item.region,
                    "车厢座位号": item.seatNumber,
                    "序列号": item.serialNumber,
                    "下车车站": item.stationGetoff,
                    "上车车站": item.stationGeton,
                    "乘车时间": item.time,
                    "座位等级": item.trainSeatLevel,
                  }
                  return newObj
                })
              } else {
                this.busShipTickets = []
              }

              // 过路费发票
              if (data.tollTickets && data.tollTickets.length > 0) {
                this.tollTickets = data.tollTickets.map(item => {
                  let newObj = {
                    "原始票据类型": item.originType,
                    "票据类型编码": item.billTypeInvoice,
                    "省": item.province,
                    "市": item.city,
                    "发票代码": item.billingNo,
                    "发票号码": item.billingCode,
                    "开票日期（出口日期）": item.billingTime,
                    "时间（出口时间）": item.time,
                    "收费入口": item.entrance,
                    "收费出口": item.exit,
                    "合计金额": item.fee,
                    "其他信息": item.extra,
                    "图片尺寸": item.imageSize,
                    "发票顺时针旋转角度": item.orientation,
                    "页码": item.page,
                    "坐标[x1, y1, x2, y2]": item.region
                  }
                  return newObj
                })
              } else {
                this.tollTickets = []
              }

              // 网约车行程单
              if (data.taxiOnlineTicket && data.taxiOnlineTicket.length > 0) {
                this.taxiOnlineTicket = data.taxiOnlineTicket.map(item => {
                  let newObj = {
                    '原始票据类型': item.originType,
                    '票据类型编码': item.billTypeInvoice,
                    '服务类型': item.serviceName,
                    '申请日期': item.applicationDate,
                    "发票号码": item.billingCode,
                    '发票代码': item.billingNo,
                    '开票日期': item.billingTime,
                    '行程开始日期': item.startDate,
                    '行程结束日期': item.destinationDate,
                    '合计金额': item.fee,
                    '合计金额(大写)': item.totalCn,
                    '乘车人电话': item.phone,

                    // '其他信息': item.extra,
                    '金额-明细列表': '',
                    '车型-明细列表': '',
                    '城市-明细列表': '',
                    '终点-明细列表': '',
                    '里程-明细列表': '',
                    '上车日期-明细列表': '',
                    '上车时间-明细列表': '',
                    '起点-明细列表': '',
                  }
                  if (item.items.length > 0) {
                    item.items.forEach((innerObj, index, array) => {
                      newObj['金额-明细列表'] += `${innerObj.amount}` ? `${innerObj.amount}${index === array.length - 1 ? '' : ' ，'}` : '';
                      newObj['车型-明细列表'] += `${innerObj.carType}` ? `${innerObj.carType}${index === array.length - 1 ? '' : ' ，'}` : '';
                      newObj['城市-明细列表'] += `${innerObj.city}` ? `${innerObj.city}${index === array.length - 1 ? '' : ' ，'}` : '';
                      newObj['终点-明细列表'] += `${innerObj.destinationPlace}` ? `${innerObj.destinationPlace}${index === array.length - 1 ? '' : ' ，'}` : '';
                      newObj['里程-明细列表'] += `${innerObj.distance}` ? `${innerObj.distance}${index === array.length - 1 ? '' : ' ，'}` : '';
                      newObj['上车日期-明细列表'] += `${innerObj.rideDate}` ? `${innerObj.rideDate}${index === array.length - 1 ? '' : ' ，'}` : '';
                      newObj['上车时间-明细列表'] += `${innerObj.rideTime}` ? `${innerObj.rideTime}${index === array.length - 1 ? '' : ' ，'}` : '';
                      newObj['起点-明细列表'] += `${innerObj.startPlace}` ? `${innerObj.startPlace}${index === array.length - 1 ? '' : ' ，'}` : '';
                    });

                  }
                  return newObj
                })
              } else {
                this.taxiOnlineTicket = []
              }
              // 印章
              if (this.type === '印章') {
                /** 
                let obj = {}
                obj = {
                  '抬头': data.major,
                  '备注1': data.minor,
                  '备注2': data.minorAarea
                }
                this.bankCard.push(obj)
                **/
              
              this.jsonData = data              
              this.bankCard = this.jsonData.map(item => {
                let obj = {}
                obj = {
                    '抬头': item.major,
                    '备注1': item.minor,
                    '备注2': item.minorAarea
                  }
                  return obj
                })
              }
            } else {
              this.invoicesDat = []
              this.taxiTickets = []
              this.trainTickets = []
              this.volumeTickets = []
              this.electricTickets = []
              this.machineTickets = []
              this.quotaInvoice = []
              this.airTickets = []
              this.busShipTickets = []
              this.taxiOnlineTicket = []
            }
          } else {
            let data = JSON.parse(response)
            this.jsonData = [data]

            this.bankCard = this.jsonData.map(item => {
              let obj = {}
              if (this.type === '银行卡') {
                obj = {
                  '银行卡号': item.bankCardNo,
                  '银行卡有效期': item.bankCardValidDate,
                  '银行名称': item.bankCardName,
                  '持卡人姓名': item.bankCardbolderName
                }
              } else if (this.type === '身份证') {
                obj = {
                  '姓名': item.idCardName,
                  '身份证号码': item.idCardIdNumber,
                  '出生日期': item.idCardBirth,
                  '签发机关': item.idCardIssueAuthority,
                  '有效期限': item.idCardValidateDate,
                  '性别': item.idCardSex,
                  '地址': item.idCardAddress,
                  '民族': item.idCardNationality,
                }
              } else if (this.type === '营业执照') {
                obj = {
                  '公司名称': item.BizLicenseCompanyName,
                  '营业执照地址': item.BizLicenseAddress,
                  '是否电子营业执照': item.BizLicenseIsElectronic,
                  '实缴资本': item.BizLicensePaidInCapital,
                  '营业执照编号': item.BizLicenseSerialNumber,
                  '是否副本': item.BizLicenseIsCopy,
                  '统一社会信用代码': item.BizLicenseCreditCode,
                  '成立日期': item.BizLicenseStartTime,
                  '组成形式': item.BizLicenseComposingform,
                  '营业期限': item.BizLicenseOperatingPeriod,
                  '法人代表': item.BizLicenseOwnerName,
                  '经营范围': item.BizLicenseScope,
                  '注册资本': item.BizLicenseRegCapital,
                  '注册日期': item.BizLicenseRegistrationDate,
                  '注册号': item.BizLicenseRegistrationCode,
                  '公司类型': item.BizLicenseCompanyType
                }
              }
              return obj
            })
            //console.log(this.bankCard, 'this.bankCard')
          }
        } else {
          this.$router.replace({
            path: '/login'
          });
          this.$message.error('session过期，请重新登录')
        }
      },
      uploadChange(file, fileList) {
        this.fileList = fileList
      },
      uploadError() {
        this.loading = false
      },
      handleClick() {

      },
      getImg(file) {
        let url = '';
        if (window.createObjectURL !== undefined) { // basic
          url = window.createObjectURL(file);
        } else if (window.URL !== undefined) { // mozilla(firefox)
          url = window.URL.createObjectURL(file);
        } else if (window.webkitURL !== undefined) { // webkit or chrome
          url = window.webkitURL.createObjectURL(file);
        }
        return url;
      },
      typeChange(e) {
        //console.log('----' + e)
        let that = this
        switch (e) {
          case '票据识别':
            that.uploadURL = that.$invoiceRecognitionUpload.url;
            that.height = document.documentElement.clientHeight - 250 + 'px'
            break;
          case '银行卡':
            that.uploadURL = that.$laiyOcrBankCardUpload.url;
            that.height = document.documentElement.clientHeight - 250 + 'px'
            break;
          case '身份证':
            that.uploadURL = that.$laiyOcrIdCardUpload.url;
            that.height = document.documentElement.clientHeight - 250 + 'px'
            break;
          case '营业执照':
            that.uploadURL = that.$laiyOcrLicenseUpload.url;
            that.height = document.documentElement.clientHeight - 250 + 'px'
            break;
          case '护照':
            that.uploadURL = that.$laiyOcrPassportUpload.url;
            that.height = document.documentElement.clientHeight - 250 + 'px'
            break;
          case '小语种':
            that.uploadURL = that.$getLanguageTypePicRecognitionData.url + `EURO_ALL_ATT_GER`;
            that.height = document.documentElement.clientHeight - 280 + 'px'
            that.selectedLang = 'EURO_ALL_ATT_GER'
            //that.getOCRSessionid()
            break;
          case '印章':
            that.uploadURL = that.$getSealMark.url;
            that.height = document.documentElement.clientHeight - 250 + 'px'
            break;
          
          default:
            console.warn('Unknown type:', e);
        }

        // 重置数据
        this.invoicesDat = [];
        this.taxiTickets = [];
        this.trainTickets = [];
        this.volumeTickets = [];
        this.electricTickets = [];
        this.machineTickets = [];
        this.quotaInvoice = [];
        this.airTickets = [];
        this.busShipTickets = [];
        this.taxiOnlineTicket = [];
        this.imgUrl = '';
        this.fileName = '';
        this.pdfBase64 = ''
        this.jsonData = []
        this.invoicesData = []
        this.bankCard = []
      },
      getOCRSessionid() {
        this.$axios({
          url: 'https://api-aiocr.cloud-sh.com/v3/api/login',
          method: "post",
          data: {
            // 'userNo': "qianchui",
            // 'password': "qianchui@0520",
            'userNo': "hitisoft",
            'password': "hitisoft@0520",
            'loginInfo': "string"
          },
        }).then((res) => {
          if (res.data.data.code === "10000") {
            let data = res.data.data.data
            let sessionId = ''
            let arr = data.split('=')
            if (arr.length > 1) {
              sessionId = arr[1]
            }
          }
        });
      },
      selectedLangChange(v) {
        this.uploadURL = this.$getLanguageTypePicRecognitionData.url + `${v}`;
        this.selectedLang = v
        this.jsonData = []
        this.pdfBase64 = ''
        this.imgUrl = ''
        this.fileName = ''
      }
    }
  }
</script>
<style>
  .bill-wrap {
    height: 100%;
    background: #fff;
    margin: 20px 10px 20px 20px;

    .el-upload-list {
      display: none;
    }


    .bill-header {
      display: flex;
      justify-content: space-between;
      padding: 10px;
      border-bottom: 1px solid #ddd;

      >div:first-child {
        display: flex;
        justify-content: space-between;
        align-items: center;
        width: 100%;
      }

      .flex-wrap {
        display: flex;
        align-items: center;
        width: 50%;

        .el-radio--mini.is-bordered {
          margin: 3px !important;
        }

        .el-radio__label {
          color: #333 !important;
          font-size: 13px;
        }
      }

      h3 {
        font-weight: 550;
        padding: 10px 0;
      }
    }

    .content {
      display: flex;
      margin: 20px;
      height: calc(100% - 130px);
      background-color: #f9f9f9;
      border-radius: 5px;

      .left {
        width: 60%;
        height: 100%;
        position: relative;
        overflow: hidden;

        .img-sty {
          position: absolute;
          top: 50%;
          left: 50%;
          -webkit-transform: translate(-50%, -50%);
          -moz-transform: translate(-50%, -50%);
          transform: translate(-50%, -50%);
          width: 80%;
        }

        .upload-demo {
          margin: 20px;
          height: 100%;
        }

        .text {
          position: absolute;
          top: 50%;
          left: 50%;
          -webkit-transform: translate(-50%, -50%);
          -moz-transform: translate(-50%, -50%);
          transform: translate(-50%, -50%);
        }

        .el-upload {
          width: 100%;
          height: calc(100% - 50px);

          .el-upload__text {
            position: absolute;
            top: 60%;
            left: 50%;
            -webkit-transform: translate(-50%, -50%);
            -moz-transform: translate(-50%, -50%);
            transform: translate(-50%, -50%);
          }
        }

        .el-upload-dragger {
          width: 100%;
          height: 100%;
          border-color: #ddd;
          position: relative;

          &:hover {
            border-color: #000000 !important;
          }

          .el-icon-upload {
            font-size: 130px;
          }
        }

        .el-upload__tip {
          text-align: center;
        }
      }

      >.right {
        /* border-left: 1px solid #ddd; */
        width: 40%;
        background-color: #f1f1f1;
        /* padding: 20px; */
        position: relative;

        .ocr-sty {
          overflow-y: scroll;
          background: #fff;
          border: 1px solid #eee;
          border-radius: 5px;

          .el-form-item {
            margin-bottom: 0 !important;
          }

          .el-form-item:first-child {
            .el-form-item__content {
              margin-left: 200px;
              font-size: 18px;
              color: #d30000;
              font-weight: 600;
            }
          }
        }

        .el-icon-document {
          color: #C0C4CC;
          position: absolute;
          top: 50%;
          left: 50%;
          -webkit-transform: translate(-50%, -50%);
          -moz-transform: translate(-50%, -50%);
          transform: translate(-50%, -50%);
          font-size: 6rem;
        }

        .el-form-item__label {
          color: #818181;
        }

        .el-form-item__content {
          color: #000;
        }
      }
    }
  }

  .el-image-viewer__wrapper {
    right: 45%;
  }

  .ocr-result-wrap .row span {
    display: inline-block;
    border: 1px solid #3d7fff;
    padding: 5px 20px;
    font-size: 14px;
    line-height: 20px;
    color: #3d7fff;
    margin-right: 20px;
    white-space: pre-wrap;
    border-radius: 4px;
    margin-bottom: 5px;
  }
</style>